export default __webpack_public_path__ + "static/media/Waiting.340aedd4.svg";